// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayersEditor_wrapper__1OQEh"};